import {
    createStore
} from 'vuex';

// Get local store
import actions from '@/BuyNow/store/actions.js';
import state from '@/BuyNow/store/state.js';
import mutations from '@/BuyNow/store/mutations.js';
import getters from '@/BuyNow/store/getters.js';

export const store = createStore({
    state,
    mutations,
    actions,
    getters,
    strict: process.env.NODE_ENV !== 'production'
})
